export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceMailMagazineSetting: {
        serviceMailMagazineId: 2,
        serviceMailMagazineUuid: "mailmagazine002",
        mailMagazineName: "メルマガ002",
        mailMagazineAddress: "aaa@aaa.com",
        deliveryTypeMstId: 6,
        deliveryTypeMstUuid: "deliverytypemst006",
        noticeTypeMstId: 1,
        noticeTypeMstUuid: "noticeType001",
        keyWords: ["防災メルマガ"],
        keywordsQueryKbn: 1,
        exclusiveKeyWords: ["防災", "緊急"]
      }
    }
  }
}